import {
  consoleBeauty,
  createManifest,
  getFirstInArray,
  getLocalToken,
  isIdentical,
  isObjectEmpty,
  isValidToken,
  saveMap,
  saveParseJson,
  saveStringify,
  setLocalStorageItem,
} from "data/functions";

// import { hasAuthParams, useAuth } from "react-oidc-context";
import logo from "data/images/logo.webp";
import { del, get, set } from "idb-keyval";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";

import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import { ReactKeycloakProvider, useKeycloak } from "@react-keycloak/web";
import { GetCacheQuery } from "components/gql/queris/GetCache";
import { GetAlertData } from "./AlertContext";
import { GetCInfo } from "./CompanyContext";
import { GetData } from "./DataContext";

export const TAuthContext = React.createContext();

function TAuthProvider({ children }) {
  const { keycloak } = useKeycloak();
  const [errCount, setErrCount] = React.useState(0);
  const { clearCache, dataObj, forceSetDataObj } = GetData();
  const [trigger, setTrigger] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [cacheCheck, setCacheCheck] = React.useState(false);
  const [refetchCacheQuery] = GetCacheQuery();
  // const auth = useAuth();
  const { setAlert } = GetAlertData();
  const { cInfo, setCInfo } = GetCInfo();
  // const logoT = require("data/images/logo.webp");

  // createManifest(window.location.origin + logoT);
  async function login() {
    if (keycloak?.authenticated) {
      // setAlert("User is authenticated");
    } else {
      // setAlert("User is not authenticated");
      await keycloak.login({
        clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        clientSecret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
        grantType: "password",
        // flow: "implifit",
        redirectUri: window.location.origin,
      });
    }
  }

  async function refreshToken() {
    try {
      const refreshed = await keycloak.updateToken(20);
      if (refreshed) {
        updateTokenData(keycloak?.token, keycloak?.idTokenParsed);
      }
    } catch (error) {
      if (error) setAlert("Failed to refresh the token:" + error, "error");
    }
  }

  function updateTokenData(token, tokenParsed) {
    if (token) {
      forceSetDataObj(token, "token");
      setLocalStorageItem("token", token);
      consoleBeauty("Токен обновлен", "KeyCloak", "dimgrey");
    }
    if (tokenParsed) {
      let data = tokenParsed;
      if (data?.company_uuid) {
        setCInfo(data?.company_uuid, "UUID");
      }
      if (data?.user_uuid) {
        forceSetDataObj(data?.user_uuid, "userID");
      }
      if (data?.name) {
        forceSetDataObj(data?.name, "clientName");
      }
    }
  }

  keycloak.onReady = () => login();
  keycloak.onAuthSuccess = () => {
    // setAlert("Authenticated!");

    updateTokenData(keycloak?.token, keycloak?.idTokenParsed);
  };
  keycloak.onAuthError = (e) => {
    setErrorMessage("Ошибка авторизации!");
    // setAlert("Ошибка при авторизации!");
  };
  keycloak.onAuthRefreshSuccess = () => {
    // setAlert("onAuthRefreshSuccess !")
  };
  keycloak.onAuthRefreshError = () => {
    // sendTelegram("Не удалось обновить токен!");
    setErrorMessage("Не удалось обновить токен!");
    setTimeout(() => {
      login();
    }, 5000);
  };
  keycloak.onTokenExpired = () => {
    // setAlert("onTokenExpired  !");
    refreshToken();
  };

  useEffect(() => {
    if (dataObj?.needToRefreshToken) {
      refreshToken();
      forceSetDataObj(false, "needToRefreshToken");
    }
  }, [dataObj?.needToRefreshToken]);

  React.useEffect(() => {
    if (dataObj?.payType !== "self-service") {
      refreshToken();
      const interval = setInterval(() => {
        refreshToken();
      }, 1 * 60 * 1000);
      return () => clearInterval(interval);
    }

    // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, []);

  async function sendTelegram(str) {
    const requestOptions = {
      method: "GET",
      // mode: "no-cors",
      redirect: "follow",
    };

    return await fetch(
      "https://api.telegram.org/bot5242346468:AAG734UY210NeOP1EgNb6VQgfqbSp3PbG-4/sendMessage?chat_id=1479499377&text=" +
        saveStringify(str),
      requestOptions
    )
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        return result;
      })
      .catch((error) => {
        console.error(error?.message);
        return [];
      });
  }

  React.useEffect(() => {
    // if (auth?.isLoading) return;
    if (keycloak?.authenticated) getCache();
    // else {
    //   // refreshToken(false);
    // }
  }, [keycloak?.authenticated]);

  // React.useEffect(() => {
  //   if (auth?.isLoading) return;
  //   if (auth?.isAuthenticated) getCache();
  //   else {
  //     // refreshToken(false);
  //   }
  // }, [auth?.isAuthenticated, auth?.isLoading]);

  // React.useEffect(() => {
  //   if (auth?.user?.access_token) {
  //     setLocalStorageItem("token", auth?.user?.access_token);
  //     set("oidc", JSON.stringify(auth?.user));
  //   }
  // }, [auth?.user]);

  async function getCache() {
    try {
      await refetchCacheQuery({})
        .then((e) => {
          if (!isObjectEmpty(e?.data?.acc_getCache)) {
            saveMap(e?.data?.acc_getCache, "TAuthProvider.getCache")?.forEach(
              (element) => {
                let value = saveParseJson(element?.value);
                if (!isIdentical(dataObj[element?.key], value)) {
                  forceSetDataObj(value, element?.key);
                }
              }
            );
          }
          setCacheCheck(true);
        })
        .catch(() => {
          setCacheCheck(true);
        });

      // console.log("Token refreshed successfully");
    } catch (error) {}
    setCacheCheck(true);
  }

  return (
    <TAuthContext.Provider value={""}>
      {!cacheCheck && <Progress message={errorMessage} />}
      {cacheCheck && children}
    </TAuthContext.Provider>
  );
}

export { TAuthProvider };

function Progress(props) {
  const ProgressBlock = ({ color, rate, size, thickness = undefined }) => {
    const [value, setValue] = useState(0);

    React.useEffect(() => {
      const timer = setInterval(() => {
        setValue((e) => (e >= 10000 ? 0 : e + 10));
      }, rate);

      return () => {
        clearInterval(timer);
      };
    }, []);

    return (
      <CircularProgress
        size={size}
        sx={{ color: color, position: "absolute" }}
        thickness={thickness}
        value={value}
        variant="determinate"
      />
    );
  };

  return (
    <Paper
      sx={{
        alignItems: "center",
        // background: "#fff",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        position: "absolute",
        width: "100%",
        zIndex: "1300",
      }}
    >
      <ProgressBlock color="#1976d20f" rate={200} size={160} />
      <ProgressBlock color="#2d5ca50f" rate={100} size={130} thickness={1.6} />
      <ProgressBlock color="#2bd2190a" rate={150} size={115} thickness={6.6} />

      <Typography variant="h5">{props?.message}</Typography>
    </Paper>
  );
}
